import { get, patch, put, post, del, getFile, patchFormData, postFormData } from "./api";
import * as url from "./url";
import axiosApi from "./api";
import axios from "axios";

// Dashboard (sin filtros básicos)
export const getDashboard = () => get(url.DASHBOARD);

// Dashboard con filtros (periodo, fechas, contacto)
export const getDashboardData = (params = {}) => {
  try {
    const filteredParams = Object.entries(params)
      .filter(([_, value]) => value !== null && value !== undefined && value !== '')
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    const queryString = new URLSearchParams(filteredParams).toString();
    return get(`${url.DASHBOARD}${queryString ? `?${queryString}` : ''}`);
  } catch (error) {
    console.error('Error al obtener dashboard con filtros:', error);
    throw error;
  }
};

// Authentication
export const postLogin = (data) => post(url.LOGIN, data);
export const getMe = () => get(url.ME);
export const postLogout = () => post(url.LOGOUT);

//Rol
export const postRolCreate = (data) => post(url.ROL, data);
export const getRolList = () => get(url.ROL);
export const getRolRead = (id) => get(`${url.ROL}${id}/`);
export const getRolFilter = (changeUrl) =>
  get(`${url.ROL}${changeUrl.changeUrl}`);
export const getRolFullList = () => get(url.ROL_FULLLIST);
export const patchRolUpdate = (id, data) => patch(`${url.ROL}${id.id}/`, data);
export const deleteRol = (id) => del(`${url.ROL}${id}/`);
export const postPermissionToGroup = (data) => post(url.PERMISSION_GROUP, data);

//USER
export const postUserCreate = (data) => post(url.USER, data);
export const putUpdatePassword = (id, data) =>
  put(`${url.USER}${id.id}/update_password/`, data);
export const getUserList = () => get(url.USER);
export const getUserRead = (id) => get(`${url.USER}${id}/`);
export const getUserFilter = (changeUrl) =>
  get(`${url.USER}${changeUrl.changeUrl}`);
export const getUserFullList = () => get(url.USER_FULLLIST);
export const patchUserUpdate = (id, data) =>
  patch(`${url.USER}${id.id}/`, data);
export const deleteUser = (id) => del(`${url.USER}${id}/`);
export const getPermission = () => get(url.PERMISSION);
export const postPermissionToUser = (data) => post(url.PERMISSION_USER, data);
export const patchPermissionToUser = (id, data) =>
  patch(`${url.USER}${id}/add_permissions_to_user/`, data);
export const getModules = () => get(`/modulo`);
export const patchModules = (id, data) => patch(`/modulo/${id}`, data);
export const patchSubmodules = (id, data) => patch(`/submodulo/${id}`, data);
export const getSessionHistory = (id, date) =>
  get(`/session_history/user_session_history/?contact_id=${id}${date}`);
export const postStartPause = (data) =>
  post(`/session_history/start_pause/`, data);
export const postEndPause = () => post(`/session_history/end_pause/`);
export const postUserLocationUpdate = (id, data) => post(`${url.USER}${id}/update_location/`, data);
export const getUserLocationHistory = (id, date) => get(`${url.USER}${id}/history/?date=${date}`);
export const postUserUpdate = (data) => postFormData(`${url.CONTACTS}actualizar_campos_usuario/`, data);

//ACCOUNT
export const postAccountCreate = (data) => post(url.ACCOUNT, data);
export const getAccountList = () => get(url.ACCOUNT);
export const getAccountRead = (id) => get(`${url.ACCOUNT}${id}/`);
export const getAccountFilter = (changeUrl) =>
  get(`${url.ACCOUNT}${changeUrl.changeUrl}`);
export const getAccountFullList = () => get(url.ACCOUNT_FULLLIST);
export const patchAccountUpdate = (id, data) =>
  patch(`${url.ACCOUNT}${id.id}/`, data);

//CAMPAIGN
export const postCampaignCreate = (data) =>
  post(`${url.CAMPAIGN}create_campaign/`, data);
export const getCampaignList = () => get(url.CAMPAIGN);
export const getCampaignRead = (id) => get(`${url.CAMPAIGN}${id}/`);
export const getCampaignFilter = (changeUrl) =>
  get(`${url.CAMPAIGN}${changeUrl.changeUrl}`);
export const deleteCampaign = (id) => del(`${url.CAMPAIGN}${id}/`);
export const getCampaignFullList = () => get(url.CAMPAIGN_FULLLIST);
export const patchCampaignUpdate = (id, data) =>
  patch(`${url.CAMPAIGN}${id.id}/`, data);
export const getContactsOfCampaign = (id) =>
  get(`${url.CONTACTS}get_contact_campaign/?campaign=${id}`);
export const getEncargadosOfCampaign = (id) =>
  get(`${url.CONTACTS}get_encargados_campaign/?campaign=${id}`);
export const postContactsOfCampaign = (id, data) =>
  post(`${url.CAMPAIGN}${id}/assign_contacts/`, data);
export const postRemoveContactsOfCampaign = (id, data) =>
  post(`${url.CAMPAIGN}${id}/remove_contacts/`, data);
export const postEncargadoOfCampaign = (id, data) =>
  post(`${url.CAMPAIGN}${id}/add_encargados/`, data);
export const postRemoveEncargadosOfCampaign = (id, data) =>
  post(`${url.CAMPAIGN}${id}/remove_encargados/`, data);
export const postAvailability = (data) =>
  post(`/campaign/horario_campaign/`, data);
export const postAvailabilityException = (data) =>
  post(`/campaign/excepcion_horario/`, data);
export const delAvailabilityException = (id) =>
  del(`/campaign/excepcion_horario/${id}`);
export const delAvailability = (id) => del(`/campaign/horario_campaign/${id}/`);

//AUDITS
export const postAuditsCreate = (data) => post(url.AUDITS, data);
export const getAuditsList = () => get(url.AUDITS);
export const getAuditsRead = (id) => get(`${url.AUDITS}${id}/`);
export const getAuditsFilter = (changeUrl) =>
  get(`${url.AUDITS}${changeUrl.changeUrl}`);
export const getAuditsFullList = () => get(url.AUDITS_FULLLIST);
export const patchAuditsUpdate = (id, data) =>
  patch(`${url.AUDITS}${id.id}/`, data);

//LEADS
export const postLeadsCreate = (data) => post(url.LEADS, data);
export const getLeadsList = () => get(url.LEADS);
export const getLeadsFinishedList = () => get(`${url.LEADS}leads_finalizados/`);
export const getLeadsRead = (id) => get(`${url.LEADS}${id}/`);
export const getLeadsFilter = (changeUrl) =>
  get(`${url.LEADS}${changeUrl.changeUrl}`);
export const getLeadsFilterCount = (changeUrl) =>
  get(`${url.LEADS}${changeUrl}`);
export const getLeadsFullList = () => get(url.LEADS_FULLLIST);
export const patchLeadsUpdate = (id, data) =>
  patch(`${url.LEADS}${id.id}/`, data);
export const postExcelLeads = (data) =>
  post(`${url.LEADS}upload_programacion/`, data);
export const postLeadsStatusChange = (id, data) =>
  post(`${url.LEADS}${id}/cambiar_estado/`, data);
export const postLandingPage = (data) => post(`/leads/event/`, data);
export const postBroadcastCampaign = (data) =>
  post(`/leads/campaign_broadcasts/`, data);
export const getBroadcastCampaign = () => get(`/leads/campaign_broadcasts/`);
export const getBroadcastCampaignFilter = (changeUrl) =>
  get(`/leads/campaign_broadcasts/${changeUrl}`);
export const postBroadcastMessage = (data) =>
  post(`/leads/campaign_broadcasts/difusion/`, data);
export const postBroadcastConfirmation = (data) =>
  post(`/leads/campaign_broadcasts/send_confirmacion_servicio/`, data);
export const getLeadsforTime = (changeUrl) =>
  get(`/leads/leads/leads_por_hora/${changeUrl}`);
export const getLeadsforStages = (campaign) =>
  get(`/leads/leads/leads_por_etapa/?campaign_id=${campaign}`);
//EMbudos
export const postPipelineCreate = (data) =>
  post(`/leads/pipeline/create_with_stages/`, data);
export const postAutomationRules = (data) =>
  post(`/leads/tipificacion-etapa-pipeline/bulk_create/`, data);
export const deleteAutomationRule = (id) =>
  del(`/leads/tipificacion-etapa-pipeline/bulk_create/${id}`);
export const saveBusinesses = (data) => post(`/leads/negocios/`, data);
export const deleteBusiness = (id) => del(`/leads/negocios/${id}`);
export const getStates = () => get(`/leads/status_leads/`);
export const saveStates = (data) => post(`/leads/status_leads/`, data);
export const deleteState = (id) => del(`/leads/status_leads/${id}`);

//CONTACTS
export const postContactsCreate = (data) => post(url.CONTACTS, data);
export const postContactsUpload = (data) =>
  post(`${url.CONTACTS}upload_excel/`, data);
export const postContactsVincular = (data) =>
  post(`${url.CONTACTS}vincular-actualizar/`, data);
export const postContactsSame = (data) =>
  post(`${url.CONTACTS}crear-igualmente/`, data);
export const postGestionContactsCreate = (data) =>
  post(`/contact/gestionContacto/`, data);
export const getContactsList = () => get(url.CONTACTS);
export const getContactsWitUser = () =>
  get(`${url.CONTACTS}get_contact_with_user/`);
export const getContactsRead = (id) => get(`${url.CONTACTS}${id}/`);
export const getContactsFilter = (changeUrl) =>
  get(`${url.CONTACTS}${changeUrl.changeUrl}`);
export const getContactsForDocument = (changeUrl) =>
  get(`${url.CONTACTS}${changeUrl}`);
export const getContactsFullList = () => get(url.CONTACTS_FULLLIST);
export const patchContactsUpdate = (id, data) =>
  patch(`${url.CONTACTS}${id.id}/`, data);
export const deleteContacts = (id) => del(`${url.CONTACTS}${id}/`);
export const getAgent = () => get(url.CONTACTS_AGENT);
export const getSupervisor = () =>
  get(`${url.CONTACTS}get_contact_supervisor/`);
export const getAgentOfCampaing = (id) =>
  get(`${url.CONTACTS}get_contact_campaign_agent/?campaign=${id}`);
export const getDataUser = () => get(`${url.CONTACTS}get_data_user`);
export const postRelacion = (id, data) =>
  post(`${url.CONTACTS}${id}/crear_relacion/`, data);
export const postUpdateChatContact = (id, data) =>
  post(`${url.CONTACTS}${id}/registrar_contacto/`, data);
export const getReportSupervisor = () =>
  get(`${url.CONTACTS}reporte_supervisor/`);
export const getReportStatus = () => get(`${url.CONTACTS}reporte_status/`);

//Grupo Contacto
export const getGrupoContacto = () => get(`/contact/grupoContacto/`);
export const getGrupoContactoFilter = (changeUrl) =>
  get(`/contact/grupoContacto/${changeUrl}`);
export const getGrupoContactoFilterPaginado = (changeUrl) =>
  get(`/contact/grupoContacto/${changeUrl.changeUrl}`);

export const postGrupoContacto = (data) =>
  post(`/contact/grupoContacto/`, data);
export const postGrupoAddContacto = (id, data) =>
  post(`/contact/grupoContacto/${id}/agregar_contactos/`, data);
export const postGrupoRemoveContacto = (id, data) =>
  post(`/contact/grupoContacto/${id}/remover_contactos/`, data);
export const postGrupoExcel = (data) =>
  post(`/contact/grupoContacto/carga_masiva/`, data);
export const postGrupoContactoAdd = (id, data) =>
  post(`/contact/contacto/${id}/agregar_grupo/`, data);
export const postGrupoContactoRemove = (id, data) =>
  post(`/contact/contacto/${id}/remover_grupo/`, data);

//CONTACT_DATA
export const postContactsDataCreate = (data) => post(url.CONTACTS_DATA, data);
export const getContactsDataList = () => get(url.CONTACTS_DATA);
export const getContactsDataRead = (id) => get(`${url.CONTACTS_DATA}${id}/`);
export const getContactsDataFilter = (changeUrl) =>
  get(`${url.CONTACTS_DATA}${changeUrl.changeUrl}`);
export const getContactsDataFullList = () => get(url.CONTACTS_DATA_FULLLIST);
export const patchContactsDataUpdate = (id, data) =>
  patch(`${url.CONTACTS_DATA}${id.id}/`, data);
export const deleteContactsData = (id) => del(`${url.CONTACTS_DATA}${id}/`);
export const getContactsDataPhone = (id) =>
  get(`${url.CONTACTS_DATA}get_datos_telefono/?contact=${id}`);
export const getContactsDataMail = (id) =>
  get(`${url.CONTACTS_DATA}get_datos_email/?contact=${id}`);
export const getContactsDataAddress = (id) =>
  get(`${url.CONTACTS_DATA}get_datos_direccion/?contact=${id}`);
export const getContactsSocialData = (id) =>
  get(`${url.CONTACTS_DATA}get_datos_redes_sociales/?contact=${id}`);

//CONTACTS_DOMCUMENT
export const postContactsDocumentCreate = (data) =>
  post(url.CONTACTS_DOCUMENT, data);
export const getContactsDocumentList = () => get(url.CONTACTS_DOCUMENT);
export const getContactsDocument = (id) =>
  get(`${url.CONTACTS_DOCUMENT}get_document_contact/?contact=${id}`);
export const getContactsDocumentFullList = () =>
  get(url.CONTACTS_DOCUMENT_FULLLIST);
export const getContactsDocumentRead = (id) =>
  get(`${url.CONTACTS_DOCUMENT}${id}/`);
export const getContactsDocumentFilter = (changeUrl) =>
  get(`${url.CONTACTS_DOCUMENT}${changeUrl}`);
export const patchContactsDocumentUpdate = (id, data) =>
  patch(`${url.CONTACTS_DOCUMENT}${id.id}/`, data);
export const deleteContactsDocument = (id) =>
  del(`${url.CONTACTS_DOCUMENT}${id}/`);

//GESTION CONTACTO
export const getCalificacionContactoList = () => get(url.CALIFICACION_CONTACTO);
export const getCalificacionContactoFullList = () =>
  get(url.CALIFICACION_CONTACTO_LISTA);
export const getCalificacionContactoforCampaign = (id) =>
  get(`${url.CALIFICACION_CONTACTO}get_campaign/?campaign=${id}`);
export const getChangeCalificacionContactoList = (changeUrl) =>
  get(`${url.CALIFICACION_CONTACTO}${changeUrl.changeUrl}`);
export const patchCalificacionContactoUpdate = (id, data) =>
  patch(`${url.CALIFICACION_CONTACTO}${id}/`, data);
export const getCalificacionContactoRead = (id) =>
  get(`${url.CALIFICACION_CONTACTO}${id}/`);
export const postCalificacionContactoAdd = (data) =>
  post(url.CALIFICACION_CONTACTO, data);
export const deleteCalificacionContact = (id) =>
  del(`${url.CALIFICACION_CONTACTO}${id}/`);
export const postTypifications = (data) =>
  post(`${url.CALIFICACION_CONTACTO}registrar_calificaciones/`, data);

export const getTipoGestionContactoList = () => get(url.TIPO_GESTION_CONTACTO);
export const getTipoGestionContactoFullList = () =>
  get(url.TIPO_GESTION_CONTACTO_LISTA);
export const getChangeTipoGestionContactoList = (changeUrl) =>
  get(`${url.TIPO_GESTION_CONTACTO}${changeUrl.changeUrl}`);
export const patchTipoGestionContactoUpdate = (id, data) =>
  patch(`${url.TIPO_GESTION_CONTACTO}${id}/`, data);
export const getTipoGestionContactoRead = (id) =>
  get(`${url.TIPO_GESTION_CONTACTO}${id}/`);
export const postTipoGestionContactoAdd = (data) =>
  post(url.TIPO_GESTION_CONTACTO, data);

export const getDescripcionCalificacionList = () =>
  get(url.DESCRIPCION_CALIFICACION);
export const getDescripcionCalificacionFullList = () =>
  get(url.DESCRIPCION_CALIFICACION_LISTA);
export const getChangeDescripcionCalificacionList = (changeUrl) =>
  get(`${url.DESCRIPCION_CALIFICACION}${changeUrl.changeUrl}`);
export const postDescripcionCalificacionAdd = (data) =>
  post(url.DESCRIPCION_CALIFICACION, data);
export const patchDescripcionCalificacionUpdate = (id, data) =>
  patch(`${url.DESCRIPCION_CALIFICACION}${id}/`, data);
export const getDescripcionCalificacionRead = (id) =>
  get(`${url.DESCRIPCION_CALIFICACION}${id}/`);
export const getDescripcionCalificacion = (id) =>
  get(`${url.DESCRIPCION_CALIFICACION}get_descripcion?calificacion=${id}`);

export const postGestionesContactoCreate = (data) =>
  post(url.GESTION_CONTACTO, data);
export const getGestionesContactoList = () => get(url.GESTION_CONTACTO);
export const getGestionesContactoRead = (id) =>
  get(`${url.GESTION_CONTACTO}${id}/`);
export const getGestionesContactoFilter = (changeUrl) =>
  get(`${url.GESTION_CONTACTO}${changeUrl.changeUrl}`);
export const getGestionesContactoFilterAsync = (changeUrl) =>
  get(`/contact/gestionContacto/get_gestiones_contacto/${changeUrl}`);
export const getGestionesContactoFullList = () =>
  get(url.GESTION_CONTACTO_FULLLIST);
export const patchGestionesContactoUpdate = (id, data) =>
  patch(`${url.GESTION_CONTACTO}${id.id}/`, data);
export const getContactAgain = (filter) =>
  get(`${url.GESTION_CONTACTO}proximo_contacto/?filtro=${filter}`);

export const getReportsForHourList = (changeUrl) =>
  get(`${url.GESTION_CONTACTO}gestiones_por_hora/${changeUrl}`);
export const getReportsBot = (changeUrl) =>
  get(`${url.GESTION_CONTACTO}gestiones_por_bot/${changeUrl}`);
export const getReportsForTimeList = (changeUrl) =>
  get(`${url.GESTION_CONTACTO}tiempo_promedio_atencion/${changeUrl}`);
export const getReportTypifications = (changeUrl) =>
  get(`${url.GESTION_CONTACTO}gestiones_por_tipificacion/${changeUrl}`);
export const getReportsExcel = (changeUrl) =>
  get(`${url.GESTION_CONTACTO}exportar-excel/${changeUrl}`);

//Hoja de Vida
export const getHojaContacto = (id) =>
  get(`${url.HOJA_CONTACTO}get_hoja_de_vida/?contacto=${id}`);
export const postHojaContacto = (data) => post(url.HOJA_CONTACTO, data);
export const postExperienciaHoja = (data) => post(url.EXPERIENCIA_HOJA, data);
export const postEducacionHoja = (data) => post(url.EDUCACION_HOJA, data);
export const postConocimientoHoja = (data) => post(url.CONOCIMIENTO_HOJA, data);

//CALENDAR
export const postCalendarEvent = (data) => post(url.CALENDAR_EVENT, data);
export const getCalendarEventFullList = () => get(`${url.CALENDAR_EVENT}`);
export const getCalendarEventRead = (id) => get(`${url.CALENDAR_EVENT}${id}`);
export const patchCalendarEvent = (id, data) =>
  patch(`${url.CALENDAR_EVENT}${id}/`, data);
export const deleteCalendarEvent = (id) => del(`${url.CALENDAR_EVENT}${id}`);
export const getCalendarEventContact = (id) =>
  get(`${url.CALENDAR_EVENT}get_event_contacto/?contacto=${id}`);
export const postGestionEvent = (data) => post(url.CALENDAR_GESTION, data);
export const getEventGestion = (id) =>
  get(`${url.CALENDAR_GESTION}get_gestiones_event/?event=${id}`);
export const getBranch = () => get(`calendar/entidad/`);
export const postBranch = (data) => post(`calendar/entidad/`, data);
export const getSpecialty = () => get(`calendar/especialidad/`);
export const postSpecialty = (data) => post(`calendar/especialidad/`, data);
export const getDisponibilidad = (contactId, fecha) =>
  get(`calendar/cita/disponibilidad/?contacto_id=${contactId}&fecha=${fecha}`);
export const postCitas = (data) => post(`calendar/cita/`, data);

//CASOS
export const postCasosCreate = (data) => post(url.CASOS, data);

export const getCasosList = () => get(url.CASOS);
export const getCasosRead = (id) => get(`${url.CASOS}${id}/`);
export const getCasosEstados = (estado) =>
  get(`${url.CASOS}casos_por_estado/?estado=${estado}`);
export const getCasosEstadosFilter = (estado, changeUrl) =>
  get(`${url.CASOS}casos_por_estado/?estado=${estado}${changeUrl}`);
export const getCasosFilter = (changeUrl) => get(`${url.CASOS}${changeUrl}`);
export const getCasosFullList = () => get(url.CASOS_FULLLIST);

export const patchCasosUpdate = (id, data) =>
  patch(`${url.CASOS}${id.id}/`, data);
export const patchCasosUpdateInfomre = (id, data) =>
  patch(`${url.CASOS}${id}/actualizar_informe/`, data);
export const postCasosStatusChange = (id, data) =>
  post(`${url.CASOS}${id}/cambiar_estado/`, data);
export const postCasosMaterials = (data) =>
  post(`${url.CASOS_MATERIALS}`, data);
export const postCasoUpdateContacto = (id, data) =>
  post(`${url.CASOS}${id}/asignar_contacto/`, data);
export const postFinalizarCaso = (id, data) =>
  postFormData(`${url.CASOS}${id}/finalizar_caso/`, data);
export const postEnviarInformeManual = (data) =>
  post(`${url.CASOS}enviar_informe_manual/`, data);
export const postAsignarCasosMasivos = (data) =>
  post(`${url.CASOS}asignar_casos_masivo/`, data);

export const postImagenesInforme = (data) =>
  postFormData(`${url.CASOS}upload_images_informe/`, data);
export const postReabrirCasos = (id) =>
  post(`${url.CASOS}${id}/reabrir-caso/`);

export const getM3Gratis = () =>
  get(`${url.CASOS}m3_gratis_mes_actual`);

// Validación de m³ gratis por cuenta de contrato (nuevo endpoint)
// Ejemplo de ruta: /casos/casos/validar_m3_gratis/?cuenta_contrato=70349366
// Parámetro: cuentaContrato (string | number)
export const getValidarM3Gratis = (cuentaContrato) =>
  get(`/casos/casos/validar_m3_gratis/?cuenta_contrato=${encodeURIComponent(cuentaContrato)}`);


//TASKS
export const postTasksCreate = (data) => post(url.TASKS, data);
export const getTasksFullList = () => get(`${url.TASKS}FullList`);

//Survey
export const postSurveyFullFlowsCreate = (data) =>
  post(`${url.SURVEY}flows/create-full-flow/`, data);
export const postSurveyFlowsCreate = (data) =>
  post(`${url.SURVEY}flows/`, data);
export const getFlowWithSteps = (id) => get(`${url.SURVEY}flows/${id}`);
export const deleteSurveyStep = (id) => get(`${url.SURVEY}steps/${id}`);
export const deleteSurveyOption = (id) => get(`${url.SURVEY}options/${id}`);
export const postSurveyStepCreate = (data) => post(`${url.SURVEY}steps/`, data);
export const patchSurveyStep = (id, data) =>
  patch(`${url.SURVEY}steps/${id}`, data);
export const postSurveyOptionsCreate = (data) =>
  post(`${url.SURVEY}options/`, data);
export const putNextStep = (id, data) => put(`${url.SURVEY}steps/${id}`, data);

//Chat
export const getAllChat = (number) =>
  get(`${url.WHATHSAPP_CHAT}?phone_number=${number}`);
export const postWhatsappMessage = (data) => post("sendMessage/", data);
export const postPdfMasive = (data) =>
  post("whatsapp/conversation/send_masiva/", data);
export const postTelegramMessage = (data) =>
  post("telegram/sendMessage/", data);
export const getWhatsappPriority = () => get("whatsapp/prioridad");
export const patchWhatsappPriority = (id, data) =>
  patch(`whatsapp/prioridad/${id}/`, data);
export const getWhatsappAtajos = () =>
  get("whatsapp/respuesta_rapida/FullList");
export const postWhatsappAtajos = (data) =>
  post("whatsapp/respuesta_rapida/", data);
export const patchWhatsappAtajos = (id, data) =>
  patch(`whatsapp/respuesta_rapida/${id}/`, data);

export const getTemplates = () => get("whatsapp/template/");
export const getTemplatesFilter = (changeUrl) =>
  get(`whatsapp/template/${changeUrl}`);
export const postTemplate = (data) => post("whatsapp/template/", data);

export const getBandejaDeEntrada = () => get("chat/message/get_inbox/");

//Conversations
export const getNewConversations = () =>
  get(`${url.CONVERSATIONS}get_conversation_new`);
export const getNewConversationsFilter = (changeUrl) =>
  get(`${url.CONVERSATIONS}get_conversation_new/${changeUrl}`);
export const getConversationsGestion = () =>
  get(`${url.CONVERSATIONS}get_conversation_gestion`);
export const getConversationsGestionFilter = (changeUrl) =>
  get(`${url.CONVERSATIONS}get_conversation_gestion/${changeUrl}`);
export const postAssignConversation = (number) =>
  post(`${url.CONVERSATIONS}${number}/assign_agent/`);
export const putGuardarGestion = (id, data) =>
  put(`${url.GESTION_CONTACTO}guardar_gestion/?contacto=${id}`, data);
export const getGestionFinalizadas = (option) =>
  get(`${url.GESTION_CONTACTO}get_gestion_finalizada/?frecuencia=${option}`);
export const getGestionPorContacto = (id) =>
  get(`${url.GESTION_CONTACTO}get_gestiones_contacto?contact=${id}`);
export const postAddNotes = (number, note) =>
  post(
    `${url.CONVERSATIONS}${number}/conversation_type_nota/?message_nota=${note}`
  );
export const postTransferAgent = (number, data) =>
  post(`${url.CONVERSATIONS}${number}/transfer_conversation/`, data);
export const postTransferCampaign = (number, campaign, data) =>
  post(
    `${url.CONVERSATIONS}${number}/transfer_conversation/?new_campaign=${campaign}`,
    data
  );
export const postCreateConversation = (data) =>
  post(`${url.CONVERSATIONS}get_or_create_conversation/`, data);

//ISSABEL
export const getIssabelReportList = () => get("issabel/call_records/");
export const getIssabelReportFilter = (change) =>
  get(`issabel/call_records/${change}`);

export const getCallStart = (data) => post("issabel/make_call/", data);
export const getCallEnd = (data) => post("issabel/hangup/", data);

//TASK
export const getTask = (number) => get(`${url.TASKS}project/${number}/`);
export const readTask = (number) => get(`${url.TASKS}task/${number}/`);
export const postTask = (data) => post(`${url.TASKS}task/`, data);
export const patchTask = (id, data) => patch(`${url.TASKS}task/${id}`, data);
export const delTask = (id) => del(`${url.TASKS}task/${id}`);
export const postComments = (data) => post(`${url.TASKS}comments-task/`, data);
export const postFlow = (data) => post(`${url.TASKS}flow/`, data);
export const patchFlow = (id, data) => patch(`${url.TASKS}flow/${id}`, data);
export const delFlow = (id) => del(`${url.TASKS}flow/${id}`);
export const postStepComment = (data) => post(`${url.TASKS}comments/`, data);
export const postStep = (data) => post(`${url.TASKS}step/`, data);
export const patchStep = (id, data) => patch(`${url.TASKS}step/${id}`, data);
export const taskForContact = (project) =>
  get(`${url.TASKS}task/by_contact/?project_id=${project}`);
export const postCompleteTask = (id, data) =>
  post(`${url.TASKS}task/${id}/completar_tarea/`, data);
export const getTaskFilter = (changeUrl) => get(`${url.PROJECT}${changeUrl}`);
export const getfilterForContact = (changeUrl) =>
  get(`${url.TASKS}task/by_contact/${changeUrl}`);
export const getTaskStage = (changeUrl) => get(`${url.PROJECT}${changeUrl}`);
export const getTaskStageFilter = (changeUrl) =>
  get(`${url.PROJECT}${changeUrl}`);
export const postTagsForTask = (data) => post(`${url.TASKS}tag/`, data);
export const getTagsForTask = (changeUrl) => get(`${url.TASKS}tag/${changeUrl}`);


//Producto
export const postProductoCreate = (data) => post(url.PRODUCTOS, data);
export const getProductoList = () => get(url.PRODUCTOS);
export const getProductoRead = (id) => get(`${url.PRODUCTOS}${id}/`);
export const getProductoFilter = (changeUrl) =>
  get(`${url.PRODUCTOS}${changeUrl.changeUrl}`);
export const getProductoFullList = () => get(url.PRODUCTOS);
export const patchProductoUpdate = (id, data) =>
  patch(`${url.PRODUCTOS}${id.id}/`, data);
export const deleteProducto = (id) => del(`${url.PRODUCTOS}${id}/`);

//Project
export const postProjectCreate = (data) => post(url.PROJECT, data);
export const getProjectList = () => get(url.PROJECT);
export const getProjectRead = (id) => get(`${url.PROJECT}${id}/`);
export const getProjectFilter = (changeUrl) =>
  get(`${url.PROJECT}${changeUrl.changeUrl}`);
export const getProjectFullList = () => get(url.PROJECT);
export const patchProjectUpdate = (id, data) =>
  patch(`${url.PROJECT}${id}/`, data);
export const deleteProject = (id) => del(`${url.PROJECT}${id}/`);
export const getTypeProject = () => get(`${url.TASKS}project-type/`);
export const postTypeProject = (data) =>
  post(`${url.TYPE_PROJECT}create_with_stages/`, data);
export const postStageTypeProject = (data) =>
  post(`${url.TASKS}project-type-stage/`, data);

//Chat AI
export const postCreateChat = (data) => post(`ia/chats/`, data);
export const postSendMessage = (data) => post(`ia/messages/`, data);




//UpLOAD
// Permite paginación: si se pasa una URL (absolute o relativa), la usa; si no, carga la primera página
export const getUploadList = (changeUrl = null) => changeUrl ? get(changeUrl) : get(`${url.CONTACTS}mis-cargas-archivos/`);
export const getDownloadCuentas = (id) => get(`${url.CONTACTS}descargar-cuentas-contrato/${id}/`);
export const getDownloadCuentasFile = (id) => get(`${url.CONTACTS}descargar-cuentas-contrato/${id}/`);
export const postUploadCatastro = (data) => post(`${url.CONTACTS}upload-catastro-enel/`, data);
export const postUploadCiudadLimpia = (data) => post(`${url.CONTACTS}upload-catastro-ciudad-limpia/`, data);
export const postUploadRadicadosDiarios = (data) => post(`${url.CONTACTS}upload-radicados-diarios/`, data);
export const postUploadEscombros = (data) => post(`${url.CONTACTS}upload-escombros/`, data);
export const postUploadDatosBasicos = (data) => post(`${url.CONTACTS}upload-datos-basicos/`, data);
export const postUploadCau = (data) => post(`${url.CONTACTS}actualizar-campos-cau/`, data);
export const postUploadProcesosComerciales = (data) => post(`${url.CONTACTS}upload-procesos-comerciales/`, data);
export const postUploadCorrespondencia = (data) => post(`${url.CONTACTS}upload-correspondencia/`, data);

//Acta de Visita
export const getFirmasBase64 = (id) => get(`${url.CASOS}${id}/firmas_base64/`);
export const patchUpdateActa = (id, formData) => patchFormData(`${url.CASOS}${id}/actualizar_informe/`, formData);
export const patchUpdateActaAdicional = (id, formData) => patchFormData(`${url.CASOS}actualizar_informe_especifico/${id}`, formData);
export const deleteActaAdicional = (id) => del(`${url.CASOS}borrar_informe_logico/${id}/`);
export const postActaAdicional = (id, formData) => post(`${url.CASOS}${id}/crear_informe_adicional/`, formData);

//Casos Manuales
export const postCasosCenso = (data) => post(`${url.CASOS}crear_caso_censo/`, data);
//Transferir Caso
export const postTransferirCasoPatinador = (data) => post(`${url.CASOS}transferir_caso_a_patinador/`, data);

//TARIFAS
export const postTarifasCreate = (data) => post(url.TARIFAS, data);
export const getTarifasList = () => get(url.TARIFAS);
export const getTarifasById = (id) => get(`${url.TARIFAS}${id}/`);
export const getTarifasFilter = (changeUrl) => get(`${url.TARIFAS}${changeUrl.changeUrl}`);
export const patchTarifasUpdate = (id, data) => patch(`${url.TARIFAS}${id}/`, data);
export const deleteTarifas = (id) => del(`${url.TARIFAS}${id}/`);
export const postTarifasBulkCreate = (data) => post(`${url.TARIFAS}bulk_create/`, data);

//ARCHIVOS
export const getListarArchivos = (changeUrl) => get(`${url.CASOS}listar_archivos_pdf/${changeUrl}`)
export const getDescargarArchivos = (changeUrl = "") => {
  const baseUrl = `${url.CASOS}descargar_archivos_pdf_zip/`;
  return changeUrl ? getFile(`${baseUrl}${changeUrl}`) : getFile(baseUrl);
};
//AFORO
export const postCasosAforo = (id, data) => post(`${url.CASOS}${id}/crear_aforo/`, data);
export const postVisitaAforo = (data) => postFormData(`${url.CASOS}agregar_visita_aforo/`, data);

//RECIPIENTES
export const getRecipientesList = () => get(`/casos/parametrizacion-recipientes/`);
export const getRecipientesFilter = (changeUrl) => get(`/casos/parametrizacion-recipientes/${changeUrl}`);
export const postRecipientes = (data) => post(`/casos/parametrizacion-recipientes/`, data);
export const patchRecipientesUpdate = (id, data) => patch(`/casos/parametrizacion-recipientes/${id}/`, data);
export const deleteRecipientes = (id) => del(`/casos/parametrizacion-recipientes/${id}/`);

//ACTIVIDADES ECONOMICAS
export const getActividadesEconomicasList = () => get(`/casos/actividades-economicas/`);
export const getActividadesEconomicasFilter = (changeUrl) => get(`/casos/actividades-economicas/${changeUrl}`);
export const postActividadesEconomicas = (data) => post(`/casos/actividades-economicas/`, data);
export const patchActividadesEconomicasUpdate = (id, data) => patch(`/casos/actividades-economicas/${id}/`, data);
export const deleteActividadesEconomicas = (id) => del(`/casos/actividades-economicas/${id}/`);

//GALERIA
export const getImagenesCuentaContrato = (changeUrl) => get(`${url.CASOS}imagenes_por_cuenta_contrato/?cuenta_contrato=${changeUrl}`);
export const postDeleteImages = (data) => post(`${url.CASOS}delete_images_informe/`, data);

//Tipo CASOS
export const getTipoCasos = () => get(`${url.CASOS}tipos_caso_disponibles/`);

//LandingPage
export const getConsultarInformes = (changeUrl) => get(`${url.CONTACTS}consultar-informes-pdf/${changeUrl}`);

//OT FINALIZADOS

// Enviar PDFs generados de OTs finalizados usando FormData
export const postCasosFinalizados = (formData) => postFormData(`${url.CASOS}actualizar_pdfs_finalizados/`, formData);
export const postHomologarCuentas = (id, formData) => postFormData(`${url.CASOS}${id}/homologar_cuenta_enel/`, formData);


//Servicios Especiales

export const getServiciosAdicionales = () => get(`${url.CASOS}servicios_adicionales_catalogo`,);
export const postServiciosAdicionales = (id, data) => post(`${url.CASOS}${id}/registrar_servicio_adicional/`, data);





export const postEnviarInformeManualSinCredenciales = (data) => {
  const API_BASE = axiosApi?.defaults?.baseURL || process.env.REACT_APP_API_URL || "";
  const urlCompleta = `${API_BASE}${url.CASOS}enviar_informe_manual/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: false,
  };
  return axios.post(urlCompleta, data, config);
};
// DESCARGAS
export const getDescargarPqrs = (fechaInicio, fechaFin) =>
  get(`casos/pqrs-export-info/?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`);
export const getDescargarEscombros = (fechaInicio, fechaFin) =>
  get(`casos/rcd-export-info/?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`);
export const getDescargarProcesosComerciales = (fechaInicio, fechaFin) =>
  get(`casos/procesos-comerciales-export-info/?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`);
export const getDescargarCorrespondencia = (fechaInicio, fechaFin) =>
  get(`casos/correspondencia-export-info/?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`);

// REPORTES
export const postGenerarReporteAgentes = (data) => post(url.REPORTES_GENERAR, data);
export const getReporteAgentesExcel = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return getFile(`${url.REPORTES_EXCEL}?${queryString}`);
};

export const getAgentDashboard = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return get(`${url.REPORTES_DASHBOARD_AGENTE}${queryString ? `?${queryString}` : ""}`);
};

export const getReporteActas = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return get(`${url.REPORTES_ACTAS}${queryString ? `?${queryString}` : ""}`);
};

export const getReporteActasExcel = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return getFile(`${url.REPORTES_ACTAS_EXCEL}${queryString ? `?${queryString}` : ""}`);
};